import { render, staticRenderFns } from "./weiboGroup.vue?vue&type=template&id=8885eac0&"
import script from "./weiboGroup.vue?vue&type=script&lang=js&"
export * from "./weiboGroup.vue?vue&type=script&lang=js&"
import style0 from "./weiboGroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports